/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity } from '@gh/core-data';
import { BulkDeleteHpListItemDto } from './bulk-delete.dto';

export const BulkDeleteHpListItemMapper = entity<BulkDeleteHpListItemDto>({
  rfqUpdated: date(DateFormat.DateTime),
  costUpdated: date(DateFormat.DateTime),
  updatedDate: date(DateFormat.DateTime),
});
